import { ICON_KEY_MAP, TIconKey } from "./Icon.config";

export const isIconKey = (icon: unknown): icon is TIconKey => (
  typeof icon === "string" && icon in ICON_KEY_MAP
);
